import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import NewPage from '../views/NewPage.vue'
import BranchVN from '../views/BranchVN.vue'
import BranchJP from '../views/BranchJP.vue'
import HuongDanGuiHang from '../views/HuongDanGuiHang.vue'
import HangXachTay from '../views/HangXachTay/HangXachTay.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // },
  // {
  //   path:'/newpage',
  //   name:'newpage',
  //   component: NewPage
  // },
  // {
  //   path:'/chi-nhanh-vn',
  //   name:'BranchVN',
  //   component: BranchVN
  // },
  // {
  //   path:'/chi-nhanh-jp',
  //   name:'BranchJP',
  //   component: BranchJP
  // },
  {
    path:'/huong-dan-gui-hang',
    name:'HuongDanGuiHang',
    component: HuongDanGuiHang
  },
  // {
  //   path:'/hang-xach-tay',
  //   name:'HangXachTay',
  //   component: HangXachTay
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
